import { useUserProperties } from "hooks/use_user_properties";
import { SizeType } from "shared/types";

const NUM_BREAKOUT_STYLES = 8;

function BreakoutGroupIndicator({ userId, size }: { userId: string; size: SizeType }) {
  const { breakout_group_title } = useUserProperties(userId, ["breakout_group_title"]) || {};
  const breakoutNumber = parseInt(breakout_group_title || "", 10);
  const breakoutStyleNumber = breakoutNumber % NUM_BREAKOUT_STYLES;

  if (!breakoutNumber) {
    return null;
  }

  return (
    <div
      className={`icon-breakout-group circle center absolute top-0 right-0 m1 bold breakout-${breakoutStyleNumber}-card`}
      style={
        size === "lg"
          ? {
              width: "32px",
              height: "32px",
              fontSize: "18px",
              lineHeight: "32px",
              zIndex: 51,
            }
          : size === "md"
            ? {
                width: "24px",
                height: "24px",
                fontSize: "12px",
                lineHeight: "24px",
                zIndex: 51,
              }
            : size === "sm"
              ? {
                  width: "16px",
                  height: "16px",
                  fontSize: "10px",
                  lineHeight: "16px",
                  zIndex: 51,
                }
              : {
                  // unsupported size
                }
      }
      data-testid={`breakout-group-indicator-${userId}`}
    >
      {breakoutNumber}
    </div>
  );
}

export { BreakoutGroupIndicator };
